import React, { useEffect } from 'react';
import PageShell from '../common/PageShell.jsx';
import PageHero from '../common/PageHero.jsx';

const About = () => {
  const expertiseAreas = [
    'Financial Markets & Global Market Analysis',
    'Equity, Derivatives & Commodities Trading',
    'Algorithm Development & Financial Technology',
    'Investment Research & Portfolio Management',
    'Business Financing & Credit Advisory',
    'Private Equity and Venture Capital',
  ];

  useEffect(() => {
    document.title = 'About Us | Eco World Capital';
  }, []);

  return (
    <PageShell>
      <PageHero
        badge="Company Profile"
        title="About Eco World Capital"
        subtitle="We are a diversified financial services and financial technology company dedicated to providing comprehensive investment, trading, and funding solutions to individuals, professionals, entrepreneurs, and businesses."
      />

      <section className="py-24 px-6 md:px-12 bg-black/10 border-y border-white/20 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-extrabold text-brand-cream mb-6">Who We Are</h2>
            <p className="text-brand-cream-muted text-lg leading-relaxed font-medium mb-6">
              Eco World Capital (EWC) is a premier group of investors and experts. Our partners bring unparalleled expertise in share trading, technology, and both fundamental and technical research.
            </p>
            <p className="text-brand-cream-muted text-lg leading-relaxed font-medium">
              By combining vast knowledge in the financial field with cutting-edge technology, our aim is to provide practical, scalable, and highly efficient solutions for modern investors and businesses.
            </p>
          </div>

          <div className="glass-card p-10 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-brand-cream/20 to-transparent pointer-events-none" aria-hidden="true" />
            <h3 className="text-2xl font-bold text-brand-gold-light mb-6 border-b border-brand-cream/20 pb-4 relative z-10">Our Core Expertise</h3>
            <ul className="space-y-5 relative z-10">
              {expertiseAreas.map((item, idx) => (
                <li key={idx} className="flex items-center space-x-4 text-brand-cream font-medium text-lg">
                  <span className="text-brand-primary bg-gradient-to-br from-brand-gold to-brand-gold-light w-8 h-8 rounded-lg flex items-center justify-center shadow-inner font-black text-sm shrink-0">
                    ✦
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-24 px-6 md:px-12 max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="section-badge mb-6">Driven By Purpose</span>
          <h2 className="text-4xl font-extrabold text-brand-cream">Our Guiding Principles</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="glass-card p-10 hover:bg-brand-cream/20 transition-all duration-300 shimmer-hover flex flex-col justify-center">
            <div className="relative z-10">
              <span className="bg-brand-cream text-brand-primary font-extrabold px-5 py-2 rounded-full text-sm mb-8 inline-block shadow-sm">OUR VISION</span>
              <p className="text-2xl text-brand-cream font-semibold leading-relaxed italic">
                "To become a trusted financial solutions and financial technology company delivering innovative investment, trading, and funding solutions across India and international markets."
              </p>
            </div>
          </div>

          <div className="glass-card p-10 hover:bg-brand-cream/20 transition-all duration-300 shimmer-hover">
            <div className="relative z-10">
              <span className="bg-gradient-to-r from-brand-gold to-brand-gold-light text-brand-primary font-extrabold px-5 py-2 rounded-full text-sm mb-8 inline-block shadow-sm">OUR MISSION</span>
              <ul className="space-y-5 text-lg text-brand-cream font-medium">
                {[
                  'Make advanced financial technology accessible to investors.',
                  'Simplify investment and financing processes.',
                  'Provide transparent and client-focused solutions.',
                  'Promote disciplined and systematic market participation.',
                ].map((item) => (
                  <li key={item} className="flex items-start space-x-3">
                    <span className="text-brand-gold font-black mt-1">✓</span>
                    <p>{item}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default About;
